/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CeleryTask } from './CeleryTask';
import { CeleryTaskFromJSON, CeleryTaskFromJSONTyped, CeleryTaskToJSON } from './CeleryTask';

/**
 * Serializer for Celery worker status.
 * @export
 * @interface CeleryStatus
 */
export interface CeleryStatus {
  /**
   *
   * @type {number}
   * @memberof CeleryStatus
   */
  workersOnline: number;
  /**
   *
   * @type {Array<CeleryTask>}
   * @memberof CeleryStatus
   */
  activeTasks: Array<CeleryTask>;
  /**
   *
   * @type {number}
   * @memberof CeleryStatus
   */
  activeTaskCount: number;
  /**
   *
   * @type {Array<CeleryTask>}
   * @memberof CeleryStatus
   */
  reservedTasks: Array<CeleryTask>;
  /**
   *
   * @type {number}
   * @memberof CeleryStatus
   */
  reservedTaskCount: number;
  /**
   *
   * @type {Array<CeleryTask>}
   * @memberof CeleryStatus
   */
  scheduledTasks: Array<CeleryTask>;
  /**
   *
   * @type {number}
   * @memberof CeleryStatus
   */
  scheduledTaskCount: number;
  /**
   *
   * @type {number}
   * @memberof CeleryStatus
   */
  queuedTasks: number;
  /**
   *
   * @type {boolean}
   * @memberof CeleryStatus
   */
  hasRunningTasks: boolean;
}

/**
 * Check if a given object implements the CeleryStatus interface.
 */
export function instanceOfCeleryStatus(value: object): value is CeleryStatus {
  if (!('workersOnline' in value) || value['workersOnline'] === undefined) return false;
  if (!('activeTasks' in value) || value['activeTasks'] === undefined) return false;
  if (!('activeTaskCount' in value) || value['activeTaskCount'] === undefined) return false;
  if (!('reservedTasks' in value) || value['reservedTasks'] === undefined) return false;
  if (!('reservedTaskCount' in value) || value['reservedTaskCount'] === undefined) return false;
  if (!('scheduledTasks' in value) || value['scheduledTasks'] === undefined) return false;
  if (!('scheduledTaskCount' in value) || value['scheduledTaskCount'] === undefined) return false;
  if (!('queuedTasks' in value) || value['queuedTasks'] === undefined) return false;
  if (!('hasRunningTasks' in value) || value['hasRunningTasks'] === undefined) return false;
  return true;
}

export function CeleryStatusFromJSON(json: any): CeleryStatus {
  return CeleryStatusFromJSONTyped(json, false);
}

export function CeleryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CeleryStatus {
  if (json == null) {
    return json;
  }
  return {
    workersOnline: json['workers_online'],
    activeTasks: (json['active_tasks'] as Array<any>).map(CeleryTaskFromJSON),
    activeTaskCount: json['active_task_count'],
    reservedTasks: (json['reserved_tasks'] as Array<any>).map(CeleryTaskFromJSON),
    reservedTaskCount: json['reserved_task_count'],
    scheduledTasks: (json['scheduled_tasks'] as Array<any>).map(CeleryTaskFromJSON),
    scheduledTaskCount: json['scheduled_task_count'],
    queuedTasks: json['queued_tasks'],
    hasRunningTasks: json['has_running_tasks'],
  };
}

export function CeleryStatusToJSON(value?: CeleryStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    workers_online: value['workersOnline'],
    active_tasks: (value['activeTasks'] as Array<any>).map(CeleryTaskToJSON),
    active_task_count: value['activeTaskCount'],
    reserved_tasks: (value['reservedTasks'] as Array<any>).map(CeleryTaskToJSON),
    reserved_task_count: value['reservedTaskCount'],
    scheduled_tasks: (value['scheduledTasks'] as Array<any>).map(CeleryTaskToJSON),
    scheduled_task_count: value['scheduledTaskCount'],
    queued_tasks: value['queuedTasks'],
    has_running_tasks: value['hasRunningTasks'],
  };
}
